export const GET_SELF_DATA_REQUEST = "GET_SELF_DATA_REQUEST";
export const GET_SELF_DATA_SUCCESS = "GET_SELF_DATA_SUCCESS";
export const GET_SELF_DATA_FAIL = "GET_SELF_DATA_FAIL";
export const GET_REPORT_DATA_REQUEST = "GET_REPORT_DATA_REQUEST";
export const GET_REPORT_DATA_SUCCESS = "GET_REPORT_DATA_SUCCESS";
export const GET_REPORT_DATA_FAIL = "GET_REPORT_DATA_FAIL";
export const GET_USER_ATTEMPTS_REQUEST = "GET_USER_ATTEMPTS_REQUEST";
export const GET_USER_ATTEMPTS_SUCCESS = "GET_USER_ATTEMPTS_SUCCESS";
export const GET_USER_ATTEMPTS_FAIL = "GET_USER_ATTEMPTS_FAIL";